import React, { useEffect, useState } from 'react';

import { useAdContext } from '../../../store/contexts/ad';
import { useAd } from '../../../store/hooks/useAd';

import { getFilteredContent } from '../../../utils/getFilteredContent';

import { List, ListItem, SearchInput, Title } from '@icarros/ids-react';
import { ListItemModifier, OpenEditTitleWrapper, OpenEditWrapper } from './style';

import { ResultsNotFound } from '../../../components/ResultsNotFound';
import { Loading } from '../../../components/Loading';
import { SaveFormContent } from './SaveFormContent';
import { useQuery } from '@tanstack/react-query';
import { getColors } from '../../../services/Edits.service';
import { GET_COLORS } from '../../../queries';

export function ColorsForm(): JSX.Element {
  const { setCurrentContent, loading } = useAd();
  const { currentAd, setValueIsDifferentFromCurrent } = useAdContext();
  const { corId = 0 } = currentAd?.veiculo || {};
  const [searchField, setSearchField] = useState('');
  const [selectedRadio, setSelectedRadio] = useState(corId);

  const { data, isInitialLoading } = useQuery({
    queryKey: [GET_COLORS],
    queryFn: () => getColors(),
    meta: {
      errorMessage: 'Tivemos um erro ao buscar as cores'
    }
  });

  const filteredColors = searchField !== '' ? data && getFilteredContent(data, searchField) : data;
  const sortedColors = filteredColors?.sort();

  useEffect(() => {
    setValueIsDifferentFromCurrent(selectedRadio !== corId);
  }, [selectedRadio, corId, setValueIsDifferentFromCurrent]);

  return (
    <OpenEditWrapper>
      <OpenEditTitleWrapper>
        <Title size="overline">editar dados do veículo</Title>
        <Title variant="default" contrast="light">
          qual a cor do seu carro?
        </Title>
        <SearchInput
          contrast="default"
          placeholder="buscar cor"
          onChange={event => setSearchField(event.target.value)}
        />
      </OpenEditTitleWrapper>

      {isInitialLoading && <Loading />}
      {!isInitialLoading && (!sortedColors || sortedColors.length === 0) && <ResultsNotFound />}

      <List>
        {sortedColors ? (
          sortedColors?.map(({ id, nome }) => (
            <ListItemModifier key={id}>
              <ListItem
                label={nome}
                variant="selector"
                radioOnChange={() => setSelectedRadio(id)}
                radioValue={id}
                radioChecked={id === selectedRadio}
                selectorName={nome}
                selectorVariant="radio"
              />
            </ListItemModifier>
          ))
        ) : (
          <></>
        )}
      </List>

      {!(isInitialLoading && selectedRadio === corId) && (
        <SaveFormContent
          loading={loading}
          isDisabled={selectedRadio === corId}
          handleClick={() =>
            setCurrentContent({
              veiculo: {
                corNome: data?.find(color => color.id === selectedRadio)?.nome,
                corId: selectedRadio
              }
            })
          }
        />
      )}
    </OpenEditWrapper>
  );
}
